import React from 'react';
import { Check, Gift } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, finalIncludedItems } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const noMore = ['No more hours searching for the next drill', 'No more disconnected session ideas', 'No more repeating the same techniques because planning time ran out', 'No more wondering which progression should come next', 'No more entering the dojo with only a loose idea', 'No more building every session from an empty page'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-[#081632] relative overflow-hidden" data-id="element-62" data-mp="vui5r5k5tad3">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-63" data-mp="vwunpipx3kq5">
        <div className="text-center mb-16" data-id="element-64" data-mp="qwq2xghz83u4">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-65" data-mp="qy16bf7if9kp">
            Next week you can keep planning every Judo session from scratch...
            <br data-id="element-66" data-mp="zy6ehrkj2bzx" />
            <span className="text-[#D89B16]" data-id="element-67" data-mp="zuii8knp7bhi">
              Or you can open a complete system and already know where to start.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/15" data-id="element-68" data-mp="2h4izesfpzink">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-69" data-mp="2r1nqn6ofa4b8">
                <span className="text-[#D89B16] mt-1" data-id="element-70" data-mp="2qzufpf6s0xxf">▸</span>
                <span className="text-white/80" data-id="element-71" data-mp="2v2hey15s1l4n">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-white mb-2" data-id="element-72" data-mp="301aqvp5f142p">
            Judo Coach Ready does not replace your knowledge as a coach.
          </p>
          <p className="text-xl text-white/80" data-id="element-73" data-mp="34vofn8pkocye">
            It gives you a system for using that knowledge with greater structure, consistency and
            efficiency.
          </p>
        </div>

        <div className="bg-white border-2 border-[#D89B16] rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-74" data-mp="3epoqzsbg6efk">
          <h3 className="text-2xl font-bold text-[#081632] mb-6 text-center border-b border-[#D89B16]/30 pb-6" data-id="element-75" data-mp="3iqqtqj4kp8ma">
            Everything included:
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-76" data-mp="1eqjszo87ybxu">
            {finalIncludedItems.map(item => <div key={item.label} className="flex items-start gap-3" data-id="element-77" data-mp="1shycdw61gf5f">
                {item.kind === 'bonus' ? <Gift size={18} className="text-[#1E4ED8] shrink-0 mt-0.5" data-id="element-78" data-mp="1no3wz4xgumc5" /> : <Check size={18} className="text-[#D89B16] shrink-0 mt-0.5" data-id="element-79" data-mp="22gny60122jqy" />}
                <span className="text-sm text-slate-700" data-id="element-80" data-mp="1xi48bojccntb">{item.label}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-81" data-mp="27e7bmxpxishu">
            <p className="text-xl font-serif font-bold text-[#081632] mb-2" data-id="element-82" data-mp="27f8uhod6sja4">🥋 JUDO COACH READY</p>
            <p className="text-sm text-slate-500 mb-8" data-id="element-83" data-mp="h29sxerzty9d">
              150 ready-to-coach Judo sessions designed to help coaches plan less, teach with more
              structure and develop better judoka from beginner fundamentals to functional
              application.
            </p>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-84" data-mp="6wia2nsw7dfi">
              🟡 GET THE COMPLETE JUDO COACHING SYSTEM NOW
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-slate-500 mb-6" data-id="element-85" data-mp="3fdd1960bv9dr">
              <span data-id="element-86" data-mp="3kcg5io8hhbko">$27 USD</span>
              <span data-id="element-87" data-mp="3kcpv4apm9gpu">• Immediate Access</span>
              <span data-id="element-88" data-mp="3kad83j504g5x">• Complete Digital Bundle</span>
            </div>
            <p className="text-lg font-serif font-bold text-[#081632]" data-id="element-89" data-mp="36dzzkzig3p3l">
              Stop building every session from scratch. Open the system, choose the session and
              coach.
            </p>
          </div>
        </div>
      </div>
    </section>;
}